import React from 'react';

/**
 * Custom hook for handling drag-and-drop events on a div element.
 * @param callback - Optional function called with the dropped key string.
 * @returns An object containing handlers for drop and drag-over events:
 *  - handleDrop: Function to handle the drop event.
 *  - handleDragOver: Function to handle the drag-over event.
 */
export const useDropZone = (callback?: (key: string) => void) => {
  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const key = e.dataTransfer.getData('text/plain');
    if (key) {
      callback?.(key);
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  return { handleDrop, handleDragOver };
};
